import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useRef } from "react";
import FloatingHearts from "@/components/FloatingHearts";
import Hero from "@/components/Hero";
import TypingLetter from "@/components/TypingLetter";
import ForgivenessSection from "@/components/ForgivenessSection";
import ReasonsGallery from "@/components/ReasonsGallery";
import VirtualHug from "@/components/VirtualHug";
import Promises from "@/components/Promises";
import Signoff from "@/components/Signoff";

const Home = () => {
  const letterRef = useRef(null);

  const scrollToLetter = () => {
    letterRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="relative paper paper-grain min-h-screen">
      <FloatingHearts />
      <div className="relative z-10">
        <Hero onBegin={scrollToLetter} />
        <div ref={letterRef}>
          <TypingLetter />
        </div>
        <Promises />
        <ReasonsGallery />
        <ForgivenessSection />
        <VirtualHug />
        <Signoff />
      </div>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
